export default class TravelInfoBlock {
  constructor(elem) {
    this.elem = elem
    this.elem.changeLink = elem.dataset.changeLink === "True"
    this.elem.travelGuideLink = elem.dataset.travelGuideLink === "True"
    this.init()
  }

  init() {
    this.changeLink()
  }

  changeLink() {
    if (this.elem.changeLink) {
      const newLink = document.getElementById("ChangeLinkString").value
      const linkElem = this.elem.querySelector("div > a[name=travelInfoLink]")
      linkElem.href = newLink
    } else if (this.elem.travelGuideLink) {
      const newLink = document.getElementById("TravelGuideLink").value
      const linkElem = this.elem.querySelector("div > a[name=travelInfoLink]")
      linkElem.href = linkElem.href + newLink
    }
  }
}
